module.exports = __webpack_public_path__ + "static/img/logo2.ea6f6333.png";